export default {
  colors: {
    default: "#bf3272",
    blue: "#4885ed",
    danger: "#db3236",
    gray: "#bfbfbf",
  },
}
